// TODO: to delete all redundant comments later
// type GetPriceListGroupColors = (theme: Theme) => [null, string, string, string, string, string, string, string, string];
// // TODO: to delete
// const getPriceListGroupColors: GetPriceListGroupColors = (theme) => {
// 	return [
// 		null,
// 		theme.palette.orange.main,
// 		theme.palette.yellow.light,
// 		theme.palette.lime.main, // theme.palette.success.main,
// 		theme.palette.teal.main, // theme.palette.emerald.main,
// 		theme.palette.text.disabled, // grey
// 		theme.palette.yellow[900], // brown
// 		theme.palette.sky.main,
// 		theme.palette.violet.dark,
// 	];
// };
const PRICE_LIST_COLOR_GROUP_KEYS = [
    null,
    'orange',
    'yellow',
    'lime',
    'teal',
    'grey',
    'brown',
    'sky',
    'violet',
];
export const getPriceListColorGroupKeys = () => PRICE_LIST_COLOR_GROUP_KEYS;
export const getPriceListGroupColorByKey = (colorGroupKey, theme) => {
    switch (colorGroupKey) {
        case 'orange':
        case 'lime':
        case 'teal':
        case 'sky':
            return theme.palette[colorGroupKey].main;
        case 'yellow':
            return theme.palette[colorGroupKey].light;
        case 'grey':
            return theme.palette.text.disabled;
        case 'violet':
            return theme.palette[colorGroupKey].dark;
        case 'brown':
            return theme.palette.yellow[900];
        default: {
            throw new Error(`Unhandled colorGroupKey case: ${colorGroupKey}`);
        }
    }
};
